import {chkObject} from "../utils/Utils";
import {cameraState} from "../../state";

const FormatCameraData = (cameraData) => {
  
  if(chkObject(cameraData.defaultPosition))
  {
    cameraState.defaultPosition = cameraData.defaultPosition;
  }
  
  if (chkObject(cameraData.defaultTarget))
  {
    cameraState.defaultTarget = cameraData.defaultTarget;
  }
  
};

export default FormatCameraData;
